import React, { Component } from 'react';
import WufooForm from 'vendor/react-wufoo-embed/ReactWufooEmbed';

export default class Contact extends Component {

  render () {
    return (
      <div>

        <h3>Contact Us</h3>
        <WufooForm userName="dreamrider" formHash="we7cb321dfoh2j" />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/contact.jsx